import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const AgreementsLine = () => /*#__PURE__*/_jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C10.1362 1 8.57006 2.27477 8.12602 4H7C5.34315 4 4 5.34315 4 7V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V7C20 5.34315 18.6569 4 17 4H15.874C15.4299 2.27477 13.8638 1 12 1ZM7 6H8.12602C8.57006 7.72523 10.1362 9 12 9C13.8638 9 15.4299 7.72523 15.874 6H17C17.5523 6 18 6.44772 18 7V19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V7C6 6.44772 6.44772 6 7 6ZM12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7ZM8 12C8 12.5523 8.45991 13 9.02724 13H14.9728C15.5401 13 16 12.5523 16 12C16 11.4477 15.5401 11 14.9728 11H9.02724C8.45991 11 8 11.4477 8 12ZM10 16C10 16.5523 10.4581 17 11.0233 17H12.9767C13.5419 17 14 16.5523 14 16C14 15.4477 13.5419 15 12.9767 15H11.0233C10.4581 15 10 15.4477 10 16Z",
    fill: "currentColor"
  })
});